import { render, staticRenderFns } from "./N8nChatWidget.vue?vue&type=template&id=29332d6d&scoped=true"
import script from "./N8nChatWidget.vue?vue&type=script&lang=js"
export * from "./N8nChatWidget.vue?vue&type=script&lang=js"
import style0 from "./N8nChatWidget.vue?vue&type=style&index=0&id=29332d6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29332d6d",
  null
  
)

export default component.exports